import { createStore } from 'vuex'

export default createStore({
  state: {
    token: "",
    wlData: null,
    userId: 0,
    browserType: 0,//默认微信浏览器，1app,2其他浏览器
    todayStar: 0,//昨日之星展示状态，0第一次展示，1不展示
    huanj: 1,//开发环境，0测试，1正式
    appid: 0//通过接口获取当前appid用来获取code，以及相关微信支付操作
  },
  getters: {
  },
  mutations: {
    setUser(state, data) {
      state.token = data.token;
      state.wlData = data.wlData;
      state.userId = data.userId;
    },
    setBrowserType(state, type) {
      state.browserType = type;
    },
    setTodayStar(state, num) {
      state.todayStar = num
    },
    setAppid(state, id) {
      state.appid = id
    }
  },
  actions: {
  },
  modules: {
  }
})
